import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutComponent } from './logout.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { DaLinkModule } from '../da-link';

@NgModule({
    declarations: [LogoutComponent],
    exports: [LogoutComponent],
    imports: [CommonModule, RouterModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([]), DaLinkModule],
    providers: []
})
export class LogoutModule {}
